import VSelectCardTicketState from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCardTicketState', VSelectCardTicketState),
};
